import { useNavigation } from '@react-navigation/native'
import React from 'react'

import { Avatar } from 'widgets/Avatar'
import { Box } from 'widgets/Box'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

import { useCurrentUser } from 'hooks/useCurrentUser'
import { useUser } from 'hooks/useUser'

import { links } from 'utils/constants'
import commonStyles from 'utils/styles/commonStyles'

type LeaderboardItemProps = {
  userId: string
  position?: number
}

export const LeaderboardItem = ({ userId, position }: LeaderboardItemProps) => {
  const navigation = useNavigation<any>()
  const { data: currentUser } = useCurrentUser()
  const { data: user } = useUser({ userId })

  const handlePress = () => {
    if (currentUser?.id === user?.id) return
    navigation.navigate(links.MEMBER_PROFILE_PAGE, {
      username: user?.username,
    })
  }

  return (
    <>
      <Pressable onPress={handlePress}>
        <Box flexDirection='row' align='center'>
          <Box testID='UsernameContainer' flex={1} flexDirection='row' align='center'>
            <Box margin='md' borderRadius='xl' style={commonStyles.overflowHidden}>
              <Avatar width={60} height={60} image={user?.avatar} />
            </Box>
            <Box flex={1} flexDirection='column' align='flex-start'>
              <Text fontSize='md' fontWeight='bold' numberOfLines={2}>
                {`${user?.firstName} ${user?.lastName}`}
              </Text>
              <Text fontSize='sm' numberOfLines={1}>
                @{user?.username}
              </Text>
            </Box>
          </Box>

          {position && (
            <Box
              testID='PositionNumberContainer'
              height='75%'
              flexDirection='row'
              align='center'
              justifyContent='center'
            >
              <Box width={54} align='center' justifyContent='center'>
                <Text fontSize='lg' color='greyDark'>{`${position.toString()}`}</Text>
              </Box>
              <Box width={1} height='100%' backgroundColor='greyLight' />
            </Box>
          )}

          <Box testID='UpscoreContainer' width={64} align='center' justifyContent='center'>
            <Text fontSize='lg' fontWeight='bold'>
              {user?.upscore?.total ?? 0}
            </Text>
          </Box>
        </Box>
      </Pressable>

      {position && (
        <Box testID='HorizontalDivider' width='100%' align='center'>
          <Box width='95%' height={1} backgroundColor='greyLight' />
        </Box>
      )}
    </>
  )
}
